"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = broadcast;

var _state = _interopRequireDefault(require("./state"));

var _heliotropeError = require("./heliotropeError");

var _types = require("./types");

var _deepMergeWithArrayMerge = _interopRequireDefault(require("./deepMergeWithArrayMerge"));

var _getCurrentTimestamp = _interopRequireDefault(require("./getCurrentTimestamp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function broadcast(options) {
  var {
    initialized,
    enabled,
    appId,
    integrations,
    context
  } = _state.default.get();

  var {
    auid
  } = _state.default.get().persistedProperties;

  var props = 'properties' in options ? options.properties : {};
  var propsWithPersisted = (0, _deepMergeWithArrayMerge.default)(_state.default.get().persistedProperties, props);

  if (!initialized) {
    _state.default.addToCache((0, _deepMergeWithArrayMerge.default)(_objectSpread({
      timestamp: (0, _getCurrentTimestamp.default)()
    }, options), {
      properties: propsWithPersisted
    }));

    return Promise.resolve({
      message: "The '".concat(options.segmentMethod, "' call was cached")
    });
  }

  if (!enabled) {
    return Promise.resolve({
      message: 'The SDK is not enabled'
    });
  }

  var propsWithAppId = (0, _deepMergeWithArrayMerge.default)(propsWithPersisted, {
    appId
  });
  return new Promise(resolve => {
    if ('timeout' in options) {
      setTimeout(resolve, options.timeout);
    }

    var segmentOptions = {
      integrations,
      context
    };

    try {
      switch (options.segmentMethod) {
        case _types.SEGMENT_METHODS.TRACK:
          {
            if (options.timestamp) {
              segmentOptions.timestamp = options.timestamp;
            }

            window.analytics.track(options.eventName, propsWithAppId, segmentOptions, resolve);
            break;
          }

        case _types.SEGMENT_METHODS.PAGE:
          {
            window.analytics.page(options.pageName, propsWithAppId, segmentOptions, resolve);
            break;
          }

        case _types.SEGMENT_METHODS.IDENTIFY:
          {
            if (auid) {
              window.analytics.identify(auid, options.traits, segmentOptions, resolve);
              break;
            }

            window.analytics.identify(options.traits, segmentOptions, resolve);
            break;
          }

        default:
          {
            throw new Error("".concat(options.type, " is not a supported analytics call"));
          }
      }
    } catch (error) {
      error.message = "".concat(_heliotropeError.errorPrefix).concat(error.message);
      throw error;
    }
  });
}

;
//# sourceMappingURL=broadcast.js.map